import $ from 'jquery';
import WindowPopup from './utils/window-popup';

class SocialSharing {
    constructor($socialLinksSelector) {
        $(document).ready(() => {
            this.shareLink = $('.js-share-btn');
            this.shareButtonsContainer = $('.js-share-btns-container');
            this.copyLink = $('.js-copy-link');
            this.linkText = $('.js-link-text');
            this.copiedTooltip = $('.js-copied-tooltip');

            // FB and Tw share links
            this.fbShare = $('.js-share-this-fb');
            this.twShare = $('.js-share-this-tw');
            this.registerListeners();
        });

        this.$socialLinksSelector = $socialLinksSelector;

        if (this.$socialLinksSelector.length > 0) {
            $('body').on('click', this.$socialLinksSelector, function (e) {
                e.preventDefault();

                WindowPopup($(this).attr('href'), 500, 300);
            });
        }
    }

    registerListeners() {
        this.shareLink.click(function () {
            $(this).hide();
            $('.js-share-btns-container').show();
        });

        this.copyLink.click(() => {
            this.linkText.select();
            document.execCommand("copy");
            this.copiedTooltip.fadeIn();
            setTimeout(() => {
                this.copiedTooltip.fadeOut();
            }, 2000);
        });

        this.fbShare.click(() => {
            let wWidth = window.innerWidth > 600 ? 600 : window.innerWidth;
            var fbpopup = window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href), "pop", "width=" + wWidth + ", height=400, scrollbars=no");
            return false;
        });
        this.twShare.click(() => {
            let wWidth = window.innerWidth > 600 ? 550 : window.innerWidth;
            var twpopup = window.open("https://twitter.com/intent/tweet?url=" + encodeURIComponent(window.location.href), "pop", "width=" + wWidth + ", height=450, scrollbars=no");
            console.log('TW SHare');
        });
    }
}

export default SocialSharing;
